import { render, staticRenderFns } from "./accpetDeclineChat.vue?vue&type=template&id=0a0cdb29&"
import script from "./accpetDeclineChat.vue?vue&type=script&lang=js&"
export * from "./accpetDeclineChat.vue?vue&type=script&lang=js&"
import style0 from "./accpetDeclineChat.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports